<template>
<div>
   <vs-row class="mb-3" >
      <vs-button color="dark" disabled type="flat"><h5>Setting / </h5></vs-button>
     <vs-button type="flat" to="/action"> <h5>Alert Setting</h5></vs-button>
     <vs-button  color="dark" disabled type="flat"><b><h5>/ Edit Alert</h5></b> </vs-button>
    </vs-row>

  <!-- <b-breadcrumb style="background-color: #ffffff; padding-left: 0px;">
    <b-breadcrumb-item active><h5>Setting</h5></b-breadcrumb-item>
    <b-breadcrumb-item to="/action"><h5>Alert Setting</h5></b-breadcrumb-item>
    <b-breadcrumb-item active><h5>Edit Alert</h5></b-breadcrumb-item>
  </b-breadcrumb> -->
  <vs-row>
    <vs-card style="border-radius: 20px;">
      <div class="mt-2" slot="header">
        <vs-row>
        <h3 style="color: #111111">
            Create / Edit Alert
          </h3>
        
       
        </vs-row>
      </div>
      
      <vs-input icon-no-border icon="notifications" label-placeholder="Alert Name"  v-model="name"/>
    </vs-card>
  </vs-row>
  <vs-row>
    <vs-card style="border-radius: 20px;">
      <h4 class="mt-2">IF (Condition​)</h4><br>
      
      <vs-table :data="conditionlist">
        <template slot="thead" >
          <vs-th class="border ">ID 
          </vs-th>
          <vs-th class="border">Sensor Type 
          </vs-th>
          <vs-th class="border">Sensor Name
          </vs-th>
          <vs-th class="border">Option
          </vs-th>
          <vs-th class="border">Value
          </vs-th>
          <vs-th class="border"> 
            Delete
          </vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data" class="border">
            <vs-td :data="data[indextr].id" class="border">
              {{data[indextr].id}}
            </vs-td>
            <vs-td class="border">
              <vs-select
                class="selectExample"
                autocomplete
                v-model="conditionlist[indextr].type"
                @change="actionchange(conditionlist[indextr].type,indextr)"
                >
                <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in sensorread" />
              </vs-select>
            </vs-td>
            <vs-td class="border">
              <vs-select
                class="selectExample"
                autocomplete
                v-model="conditionlist[indextr].sensid"
                @change="sensorchange(conditionlist[indextr].sensid,indextr)"
                >
                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in flitersensor[indextr]" />
              </vs-select>
            </vs-td>
            <vs-td class="border">
              <vs-row>
                <div v-if="conditionlist[indextr].type == 'advantech'">
                <vs-col vs-lg="6" vs-xs="12">
                  <vs-select
                    class="selectExample"
                    autocomplete
                    v-model="conditionlist[indextr].advancon"
                    >
                    <vs-select-item :key="index" :value="item.value" :text="item.name" v-for="(item,index) in address[indextr]" />
                  </vs-select>
                </vs-col>
                </div>
                <div v-else-if="conditionlist[indextr].type == 'lora'">
                <vs-col vs-lg="6" vs-xs="12">
                  <vs-select
                    class="selectExample"
                    autocomplete
                    v-model="conditionlist[indextr].loracon"
                    >
                    <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in lorakey[indextr]" />
                  </vs-select>
                </vs-col>
                </div>
                <vs-col vs-lg="6" vs-xs="12">
                <vs-select
                  class="selectExample"
                  autocomplete
                  v-model="conditionlist[indextr].con"
                  >
                  <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in sencon[indextr]" />
                </vs-select>
                </vs-col>
              </vs-row>
            </vs-td>
            <vs-td class="border">
              <vs-input v-model="conditionlist[indextr].value" v-if="conditionlist[indextr].con != 'True' && conditionlist[indextr].con != 'False'"></vs-input>
            </vs-td>
            <vs-td class="border">
               <vs-button class="text-danger mr-2 " color="danger" type="flat" icon="delete" @click="pop()">Delete</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table><br>
       <vs-button color="#007bff" class="mb-4" type="flat" icon="add" @click="addnewsens" >Add New Sensor</vs-button>
    <!-- <vs-button type="filled" @click="addnewsens">Add New Sensor</vs-button> -->
    </vs-card>
  </vs-row>
  <vs-row>
    <vs-card style="border-radius: 20px;">
      <h4 class="mt-2">THEN (Action)</h4><br>
      <vs-table :data="actionlist">
        <template slot="thead">
          <vs-th class="border">ID 
          </vs-th>
          <vs-th class="border">Type 
          </vs-th>
          <vs-th class="border">Detail 
          </vs-th>
          <vs-th class="border">Delete
          </vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data" class="border">
            <vs-td :data="data[indextr].id" class="border">
              {{data[indextr].id}}
            </vs-td>
            <vs-td :data="data[indextr].name" class="border">
              <vs-select
                class="selectExample"
                autocomplete
                v-model="actionlist[indextr].name"
                @change="alertchange(actionlist[indextr].namee,indextr)"
                >
                <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in actiontype" />
              </vs-select>
            </vs-td>
            <vs-td :data="data[indextr].detail" class="border">
              <vs-select
                v-if="actionlist[indextr].name == 'User E-mail'"
                class="selectExample"
                autocomplete
                v-model="actionlist[indextr].detail"
                @change="detailchange(actionlist[indextr].detail,indextr)"
                >
                <vs-select-item :key="index" :value="item.email" :text="item.email" v-for="(item,index) in emaillist" />
              </vs-select>
              <vs-input v-else-if="actionlist[indextr].name == 'Other E-mail'" v-model="actionlist[indextr].detail">
              </vs-input>
            </vs-td>
            <vs-td class="border">
              <vs-button class="text-danger mr-2 " color="danger" type="flat" icon="delete" @click="actpop()">Delete</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table><br>
      <vs-button color="#007bff" class="mb-4" type="flat" icon="add" @click="addnewact" >Add New Action</vs-button>
    <!-- <vs-button type="filled" @click="addnewact">Add New Action</vs-button> -->
    <vs-row class="mt-3 mb-3" vs-w="12">
        <vs-col class="mt-2 " vs-lg="12" vs-sm="12" vs-xs="12">
          <vs-button style="border-radius: 18px;" color="success" type="filled" @click="send" v-if="mode == 'create'">Create Action</vs-button>
           <vs-button style="border-radius: 18px;" color="success" type="filled" @click="send" v-if="mode == 'edit'">Save Edit</vs-button>
          <vs-button class="ml-2" color="dark" to="/action" type="flat">Cancel</vs-button>
        </vs-col>
      </vs-row>  
    </vs-card>
    <!-- <vs-button type="filled" @click="send" v-if="mode == 'create'">Create Action</vs-button>
    <vs-button type="filled" @click="send" v-if="mode == 'edit'">Save Edit</vs-button> -->
  </vs-row>
<!-- <vs-row>
  <vs-card>
    <h4 class="card-title d-flex">
      Select Binding Sensors
    </h4>
    <vs-row>
      <vs-col vs-lg="3" vs-xs="6" v-for="item in this.sensorlist" :key="item.id" >
        <vs-checkbox v-model="checkarray" :vs-value="item.serial_id" color="#333f50" style="justify-content: start;">{{item.name}}</vs-checkbox>
      </vs-col>
    </vs-row>
  </vs-card>
</vs-row>
<vs-row>
  <vs-col vs-lg="6" vs-xs="12">
      <vs-card>
        <vs-dropdown>
          <a class="a-icon" href.prevent>
            {{this.actionselect}}
            <vs-icon class icon="expand_more"></vs-icon>
          </a>
          <vs-dropdown-menu>
            <vs-dropdown-group vs-collapse vs-label="Sensor Reading" vs-icon="add">
              <vs-dropdown-item v-for="list in sensorread" :key="list" @click="actionchange(1,list)">{{list}}</vs-dropdown-item>
            </vs-dropdown-group>
            <vs-dropdown-item v-for="item in maingroup" :key="item.group" @click="actionchange(1,item.group)">
            {{item.group}}</vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </vs-card>
  </vs-col>
  <vs-col vs-lg="6" vs-xs="12">
  <vs-card v-if="this.actionselect === 'Temperature'">
    <div class="default-input d-flex align-items-center">
      <vs-dropdown>
      <a class="a-icon" href.prevent>
        {{this.con}}
        <vs-icon class icon="expand_more"></vs-icon>
      </a>
      <vs-dropdown-menu>
      <vs-dropdown-item v-for="item in sencon" :key="item" @click="actionchange(2,item)">
        {{item}}</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
      <vs-input color="#333f50" 
        label="Value"
        class="inputx ml-3"
        type="number"
        placeholder="0"
        v-model="value"
      />
    </div>
  </vs-card>
  <vs-card v-if="this.actionselect === 'Humidity'">
    <div class="default-input d-flex align-items-center">
      <vs-dropdown>
      <a class="a-icon" href.prevent>
        {{this.con}}
        <vs-icon class icon="expand_more"></vs-icon>
      </a>
      <vs-dropdown-menu>
      <vs-dropdown-item v-for="item in sencon" :key="item" @click="actionchange(2,item)">
        {{item}}</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
      <vs-input color="#333f50" 
        label="Value"
        class="inputx ml-3"
        type="number"
        placeholder="%"
        v-model="value"
      />
    </div>
  </vs-card>
  <vs-card v-if="this.actionselect === 'Powermeter'">
    <div class="default-input d-flex align-items-center">
      <vs-dropdown>
      <a class="a-icon" href.prevent>
        {{this.pt}}
        <vs-icon class icon="expand_more"></vs-icon>
      </a>
      <vs-dropdown-menu>
      <vs-dropdown-item v-for="item in powertype" :key="item" @click="actionchange(3,item)">
        {{item}}</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
      <vs-dropdown>
      <a class="a-icon" href.prevent>
        {{this.con}}
        <vs-icon class icon="expand_more"></vs-icon>
      </a>
      <vs-dropdown-menu>
      <vs-dropdown-item v-for="item in sencon" :key="item" @click="actionchange(2,item)">
        {{item}}</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
      <vs-input color="#333f50" 
        label="Value"
        class="inputx ml-3"
        type="number"
        placeholder="0"
        v-model="value"
      />
    </div>
  </vs-card>
  </vs-col>
</vs-row>
<vs-row>
  <vs-col v-if="this.actionselect !== 'Action Select'">
    <vs-row>
      <vs-card>
        <vs-select
          placeholder="Select"
          multiple
          autocomplete
          class="selectExample"
          label="Notification"
          v-model="then"
          @change="change()"
          >
          <vs-select-item :key="index" :value="item.text" :text="item.text" v-for="(item,index) in options2" />
        </vs-select>
      </vs-card>
    </vs-row>
    <vs-row v-if="this.then[0] === 'E-Mail' || this.then[1] === 'E-Mail'">
      <vs-card>
        <p>E-Mail Box</p>
        <vs-col vs-lg="6" vs-xs="12">
        </vs-col>
        <vs-col vs-lg="6" vs-xs="12">
          <vs-table stripe 
      multiple
      v-model="selected"
      :data="users"> 
      <template slot="thead">
        <vs-th>
          Email
        </vs-th>
        <vs-th>
          Name
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td>
            {{data[indextr].email}}
          </vs-td>
          <vs-td>
            {{data[indextr].name}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
        </vs-col>
      </vs-card>
    </vs-row>
    <vs-row v-if="this.then[0] === 'LINE Notification' || this.then[1] === 'LINE Notification'">
      <vs-card>
        <p>LINE Box</p>
      </vs-card>
    </vs-row>
  </vs-col>
</vs-row>
  <vs-row>
    <vs-button type="filled" size="large" v-if="this.actionselect !== 'Action Select'" color="#333f50" @click="send()">Confirm</vs-button>
  </vs-row> -->
</div>
</template>

<script>
export default {
  name: "CreateAction",
  data: () => ({
    id: '',
    assignee: '',
    controlstatus: [{name:'ON -> OFF',value:false},{name:'OFF -> ON',value:true}],
    status: [{name:'Connect',value:false},{name:'Disconnect',value:true}],
    testmode: 'Unavailable',
    sensname: [],
    actionselect:[],
    actiontype:['User E-mail','Other E-mail','LINE','Control'],
    actionlist:[{id:1,name:'',detail:''}],
    name: '',
    input: [],
    checkarray: [],
    typeselect:"Type Select",
    maingroup: [{"group":"Battery Level"},{"group":"Device Inactivity"}],
    sensorread: [],
    // powertype: ["VoltageL1","VoltageL2","VoltageL3","TotalPhaseVoltage","CurrentL1","CurrentL2","CurrentL3","TotalCurrent",
    //             "VoltageL1L2","VoltageL2L3","VoltageL3L1","TotalPtoPVoltage","ActivePowerL1","ActivePowerL2","ActivePowerL3","TotalActivePower",
    //             "ReactivePowerL1","ReactivePowerL2","ReactivePowerL3","TotalReactivePower","ApparentPowerL1","ApparentPowerL2","ApparentPowerL3","TotalApparentPower",
    //             "PowerFactorL1","PowerFactorL2","PowerFactorL3","TotalPowerFactor","Frequency","TotalimpActiveEnergy","TotalexportedActiveEnergy",
    //             "TotalimpReactiveEnergy","TotalexpReactiveEnergy","TotalApparentEnergy"],
    sencon: [["Greater Than","Less Than"]],
    address: [[]],
    thenlist: ["E-mail",""],
    pt: 'Type',
    unit: ['Celcius','Fahrenheit'],
    value: '',
    options2:[
        {text: 'E-Mail', value: 1},
        {text: 'LINE Notification', value: 2}
      ],
    then: '',
    users: [{"email":"napat@swd.co.th","name":"Pao1"},
            {"email":"sountorn@swd.co.th","name":"Pao2"},
            {"email":"pao@swd.co.th","name":"Pao3"},
            {"email":"napat2@swd.co.th","name":"Pao4"}],
    selected: [],
    emaillist: [],
    sensorlist: [],
    flitersensor: [[{name:'Select Sensor Type First!'}]],
    conditionlist: [{id:1,type:'',sensid:'',con:'',value:''}],
    tempsensorread: [],
    controlunit: [],
    formlist: [],
    mode: '',
    detail: '',
    lorakey: [["Select Sensor First!"]],
  }),
  methods: {
    pop() {
      this.flitersensor.pop()
      this.sencon.pop()
      this.lorakey.pop()
      this.conditionlist.pop()
    },
    actpop() {
      this.actionlist.pop()
    },
    addnewsens() {
      this.flitersensor.push([{name:'Select Sensor Type First!'}])
      this.sencon.push(["Greater Than","Less Than"])
      this.lorakey.push(["Select Sensor First!"])
      this.conditionlist.push({id:this.conditionlist.length+1,type:'',sensid:'',con:'',value:''})
    },
    addnewact() {
      // this.flitersensor.push([{name:'Select Sensor Type First!'}])
      // this.sencon.push(["Greater Than","Less Than"])
      this.actionlist.push({id:this.actionlist.length+1,name:'',detail:''})
    },
    alertchange(type,index) {
      // console.log(type,index)
      // console.log(this.actionlist)
    },
    detailchange(detail,index) {
      // console.log(detail,index)
    },
    addnewcontrol(){

    },
    change() {
      // eslint-disable-next-line no-console
      // console.log(this.then)
    },
    sensorchange(item,i) {
      // console.log(this.flitersensor[i], this.lorakey[i])
      // // console.log(item,i)
      if(this.address[i]) {
        while(this.address[i].length > 0) {
          this.address[i].pop();
        }
      }
      if(this.lorakey[i]) {
        while(this.lorakey[i].length > 0) {
          this.lorakey[i].pop();
        }
      }
      var lastdata
      this.flitersensor[i].forEach(element => {
        if(item == element.id) {
          lastdata = JSON.parse(element.lastdata[0])
          // console.log(lastdata)
          Object.keys(lastdata).forEach(keys => {
            switch(keys) {
              case 'p1v00r0000x06':
                this.address[i].push({name:'Total Flow',value:keys})
                break;
              case 'p1v00r0000x09':
                this.address[i].push({name:'Total Flow',value:keys})
                break;
              case 'p1v00r0000x0a':
                this.address[i].push({name:'Total Flow',value:keys})
                break;
              case 'p1v00r0000x0b':
                this.address[i].push({name:'Total Flow',value:keys})
                break;
              // case 'p1v00r0000x10':
              //   this.address[i].push({name:'Total Flow',value:keys})
              //   break;
              // case 'p1v00r0000x14':
              //   this.address[i].push({name:'Reverse Total Flow',value:keys})
              //   break;
              case 'ai1':
                this.address[i].push({name:'PH',value:keys})
                break;
            }
          });
          if(element.type == 'lora') {
            Object.keys(lastdata).forEach(keys => {
              if(keys != 'time') {
                this.lorakey[i].push(keys)
              }
            })
          }
        }
      });
    },
    actionchange(item,i) {
      while(this.flitersensor[i].length > 0) {
        this.flitersensor[i].pop();
      }
      this.sensorlist.forEach(element => {
        if(element.type == 'monnit') {
          if(element.subtype == item) {
            this.flitersensor[i].push(element)
          }
        }else if(element.type != null && element.type != '') {
          if(element.type == item) {
            this.flitersensor[i].push(element)
          }
        }
      });
      switch(item) {
        case 'Humidity':
          this.sencon[i] = ["Humidity Greater Than (%)","Humidity Less Than (%)","Greater Than (°C)","Less Than (°C)","Greater Than (°F)","Less Than (°F)"]
          break;
        case 'Temperature':
          this.sencon[i] = ["Greater Than (°C)","Less Than (°C)","Greater Than (°F)","Less Than (°F)"]
          break;
        case 'Vibration':
          this.sencon[i] = ["Greater Than","Less Than"]
          break;
        case 'CT':
          this.sencon[i] = ["Amp Greater Than","Amp Less Than"]
          break;
        case 'control':
        case 'O/C':
          this.sencon[i] = ["True","False"]
          break;
        case 'powermeter':
          this.sencon[i] = ["Amp Greater Than","Amp Less Than","Volt Greater Than","Volt Less Than"]
          break;
      }
    },
    clear() {
      this.actionselect = 'Action Select'
      this.typeselect = "Type Select"
      this.con = 'Greater Than'
      this.pt = 'Type'
      this.value = ''
    },
    // send() {
    //   // console.log(this.conditionlist,this.actionlist)
    // }
    send() {
      switch(this.mode) {
        case 'edit':
          this.$http.post(this.$url+'updateaction', {
            headers: {
              'Access-Control-Request-Method': '*',
              'Access-Control-Request-Headers': '*',
              'Origin': '*'
            },
            id: this.id,
            name: this.name,
            con: this.conditionlist,
            action: this.actionlist,
            active: true,
            token: this.$session.get('token')
          })
            this.$vs.notify({
              title: "Add Alert",
              text: "Complete!",
              color: "success",
              position: "top-center",
              icon: 'check'
          });
          setTimeout(() => {
            this.$router.push({name:'Action'})
          }, 1000);
          break;
        case 'create':
          this.$http.post(this.$url+'action', {
            headers: {
              'Access-Control-Request-Method': '*',
              'Access-Control-Request-Headers': '*',
              'Origin': '*'
            },
            name: this.name,
            con: this.conditionlist,
            action: this.actionlist,
            active: true,
            token: this.$session.get('token')
          })
          
            this.$vs.notify({
              title: "Add Alert",
              text: "Complete!",
              color: "success",
              position: "top-center",
              icon: 'check'
          });
          setTimeout(() => {
            this.$router.push({name:'Action'})
          }, 1000);
          break;
      }
    }
  },
  beforeDestroy() {
    this.$session.remove('action')
    this.$session.remove('actiondetail')
  },
  async created() {
    this.mode = this.$session.get('action')
    this.detail = this.$session.get('actiondetail')
    await this.$http.get(this.$url+'account/'+this.$session.get('token'))
    .then((result) => {
      this.emaillist = result.data
      // console.log(this.emaillist)
    })
    await this.$http.get(this.$url+'getform/'+this.$session.get('token'))
    .then((result) => {
      this.formlist = result.data
    })
    var check = false
    await this.$http.get(this.$url+'sensorid/'+this.$session.get('token'))
    .then((result) => {
      this.sensorlist = result.data
      // console.log(this.sensorlist)
      result.data.forEach(element => {
        if(element.type == 'control' || element.type == 'Control') this.controlunit.push(element)
        if(element.type == 'monnit') {
          check = false
          this.sensorread.forEach(element2 => {
            if(element2 == element.subtype) check = true
          });
          if(!check) {
            this.sensorread.push(element.subtype)
            check = false
          }
        }else if(element.type != null && element.type != '') {
          this.sensorread.forEach(element2 => {
            if(element2 == element.type) check = true
          });
          if(!check) {
            this.sensorread.push(element.type)
            check = false
          }
        }
      });
      if(this.mode == 'edit') {
        // console.log(this.detail)
        this.id = this.detail.id
        this.name = this.detail.name
        this.conditionlist = []
        this.detail.con.forEach((element,i) => {
          this.conditionlist.push(element)
        });
        this.conditionlist.forEach((element,i) => {
          this.sensorlist.forEach(sensor => {
            if(sensor.name == element.sensid) {
              element.sensid = sensor.id
            }
          });
          this.flitersensor.push([{name:'Select Sensor Type First!'}])
          this.sencon.push(["Greater Than","Less Than"])
          this.actionchange(element.type,i)
        });
        setTimeout(() => {
        this.conditionlist = []
        this.detail.con.forEach(element => {
          this.conditionlist.push(element)
        });
        // console.log(this.conditionlist,this.flitersensor)          
        }, 500);
        this.actionlist = this.detail.action
        // console.log(this.detail.action)
        // console.log(this.formlist) 
        this.actionlist.forEach(element => {
          this.formlist.forEach(form => {
            if(element.name == 'Work Order' && element.detail == form.conf.formConfig.headline) {
              element.detail = form.conf
            }
          });
          if(element.status == 'ON -> OFF') element.status = false
          else if(element.status == 'OFF -> ON') element.status = true
        });
      }
    })
  }
}
</script>
<style scoped>
.vs-button{
  border-radius: 20px;
}
.th {
  padding: 0%;
}
.border1 {
  padding: 0px;
  border-style: solid;
  border-width: 1px;
}
.border:hover {
  height: 0px;
  transition: 1000s;
}
</style>
<style >
.vs-table--thead {
  z-index: 200;
  width: 100%;
  position: static;
}
</style>